import type { IUpdateStoreRequest } from '@/common/interfaces/store.interface';
import type { ICartItemDetail } from '@/common/interfaces/cart.interface';

/**
 * Input display value. Falls back to the catalog apparel name when no custom
 * product title has been set (undefined, null, or empty/whitespace-only), so the
 * setup flow — which seeds cart items with an empty productTitle — still shows a title.
 */
export const getStoreReviewProductTitleInputValue = (item: ICartItemDetail): string => {
  if (item.productTitle && item.productTitle.trim() !== '') {
    return item.productTitle;
  }

  if (item.apparelName && item.apparelName.trim() !== '') {
    return item.apparelName;
  }

  const nestedApparelName = (item as ICartItemDetail & { apparel?: { name?: string | null } })
    .apparel?.name;

  return nestedApparelName?.trim() || '';
};

export const resolveStoreReviewProductTitle = (item: ICartItemDetail): string =>
  getStoreReviewProductTitleInputValue(item).trim();

export const buildStoreProductTitleUpdatePayload = (
  orderId: number,
  orderItemId: number,
  productTitle: string
): IUpdateStoreRequest => ({
  order_id: orderId,
  order_items: [
    {
      id: orderItemId,
      product_title: productTitle,
    },
  ],
});
